import {
  TableBody,
  TableHead,
  TableHeadingCell,
  TableRow,
  Table,
  TableCell,
  OverflowMenu,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import PropTypes from 'prop-types'
import {mobileScreenSize} from '../../../utils/constants'
import fpti from '../../../instrumentation'
import { MessageFormat } from '@paypalcorp/worldready'
import {fptiConstants} from "../../../utils/fptiConstants";

const options = (worldReady) => {
  return [
    {
      label: new MessageFormat(worldReady, {
        id: `thirdPartyPerm.actions.edit`,
      }).format(),
      value: 'EDIT',
      id: 'EDIT',
    },
    {
      label: new MessageFormat(worldReady, {
        id: `thirdPartyPerm.actions.view`,
      }).format(),
      value: 'VIEW',
      id: 'VIEW',
    },
    {
      label: new MessageFormat(worldReady, {
        id: `thirdPartyPerm.actions.delete`,
      }).format(),
      value: 'DELETE',
      id: 'DELETE',
    },
  ]
}

// to handle the opening and closing of overflow menus
const handleOverflowClick = (index, val, searchRes, setSearchRes) => {
  const newEntries = searchRes.map((e, i) => {
    if (i === index) {
      e.isOpen = val
    }
    return e
  })
  setSearchRes([...newEntries])
}

// to handle click on the overflow menu (edit, view, delete)
const handleOverflowChange = (e, entry, setToChange, sheetsStateSetter) => {
  const value = e.target.value
  fpti.recordClick({
    link: `rootPage_${value}`, // or another property holding the link
    action: value,
    event_name: `${value}_PERMISSIONS`,
    space_key: fptiConstants.SPACE_KEY,
  });
  if (value === 'DELETE') {
    setToChange(entry)
    sheetsStateSetter({ type: 'delete', value: true })
  } else if (value === 'EDIT') {
    setToChange(entry)
    sheetsStateSetter({ type: 'edit', value: true })
  } else if (value === 'VIEW') {
    setToChange(entry)
    sheetsStateSetter({ type: 'view', value: true })
  }
}

const CustomTable = ({
  windowWidth,
  APIData,
  searchRes,
  sheetsStateSetter,
  worldReady,
  setSearchRes,
  setToChange,
}) => {
  const renderRows = (entriesList) => {
    return entriesList.map((entry, index) => {
      return (
        <TableRow key={index}>
          <TableCell mobile={{ placement: 'b1' }} className="table_data_root">
            {entry.apiUsername}
          </TableCell>
          <TableCell mobile={{ placement: 'a1' }} className="table_data_root">
            {entry.Organization}
          </TableCell>
          <TableCell mobile={{ placement: 'ab3' }} className="table_data_root">
            <OverflowMenu
              id={`overflowmenu${index}`}
              options={options(worldReady)}
              onOpen={() =>
                handleOverflowClick(index, true, searchRes, setSearchRes)
              }
              isOpen={entry.isOpen}
              onClose={() =>
                handleOverflowClick(index, false, searchRes, setSearchRes)
              }
              onChange={(e) =>
                handleOverflowChange(e, entry, setToChange, sheetsStateSetter)
              }
            />
          </TableCell>
        </TableRow>
      )
    })
  }
  if (windowWidth > mobileScreenSize) {
    return (
      <Table id="entriesTable" isFullWidth>
        <TableHead>
          <TableRow>
            <TableHeadingCell>
              <Message id="thirdPartyPerm.thirdPartyUsername" />
            </TableHeadingCell>
            <TableHeadingCell>
              <Message id="thirdPartyPerm.organization" />
            </TableHeadingCell>
            <TableHeadingCell>
              <Message id="thirdPartyPerm.action" />
            </TableHeadingCell>
          </TableRow>
        </TableHead>
        <TableBody>{APIData && renderRows(searchRes)}</TableBody>
      </Table>
    )
  }
  return (
    <Table id="entriesTable" isFullWidth isResponsive={true}>
      <TableHead>
        <TableRow>
          <TableHeadingCell>
            <Message id="thirdPartyPerm.thirdPartyUsername" />
          </TableHeadingCell>
          <TableHeadingCell>
            <Message id="thirdPartyPerm.organization" />
          </TableHeadingCell>
          <TableHeadingCell>
            <Message id="thirdPartyPerm.action" />
          </TableHeadingCell>
        </TableRow>
      </TableHead>
      <TableBody>{APIData && renderRows(searchRes)}</TableBody>
    </Table>
  )
}

CustomTable.propTypes = {
  windowWidth: PropTypes.number,
  APIData: PropTypes.array,
  searchRes: PropTypes.array,
  sheetsStateSetter: PropTypes.func,
  worldReady: PropTypes.object,
  setSearchRes: PropTypes.func,
  setToChange: PropTypes.func,
}

export default CustomTable
